var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"language-pair-filter"},[_c('sk-multiselect',{attrs:{"items-list":_vm.languages,"preselected-value":_vm.filterLangs,"default-value":_vm.langDefaultValue},on:{"checkboxeschanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }